/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamUrlResponse
 */
export interface StreamUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof StreamUrlResponse
     */
    data: string;
}

/**
 * Check if a given object implements the StreamUrlResponse interface.
 */
export function instanceOfStreamUrlResponse(value: object): value is StreamUrlResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function StreamUrlResponseFromJSON(json: any): StreamUrlResponse {
    return StreamUrlResponseFromJSONTyped(json, false);
}

export function StreamUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function StreamUrlResponseToJSON(value?: StreamUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

